// extracted by mini-css-extract-plugin
module.exports = {"gsc-selected-option-container":"styles-m__gsc-selected-option-container__8gJzq"};